<template>
  <div class="py-1">
    <simple-label
      :id="name"
      :label="label"
      :label-info="labelInfo"
      :required="required"
      v-if="label != ''"
      class="border-b border-gray-100"
    ></simple-label>
    <span
      class="relative inline-block mr-5 text-sm"
      v-for="item in options"
      :key="item.id"
    >
      <input
        type="radio"
        :id="name + '-' + item.id"
        class="absolute opacity-0 bottom-0"
        :name="name"
        @change="onChange"
        :value="item.id"
        @input="emit"
        @blur="emit"
        :required="required"
        :checked="initialValue == item.id"
      />
      <label
        :for="name + '-' + item.id"
        class="flex items-center cursor-pointer"
      >
        <span
          class="flex justify-center items-center w-4 h-4 inline-block mr-1 rounded-full border border-grey"
        >
          <span class="w-2 h-2 inline-block rounded-full"></span>
        </span>
        <div v-text="item.label" class="leading-loose"></div>
      </label>
    </span>
    <span class="help danger">
      <span
        v-if="useForm && $parent.form.errors.has(name)"
        v-text="$parent.form.errors.get(name)"
      ></span>
    </span>
  </div>
</template>

<script>
import SimpleLabel from "./SimpleLabel";

export default {
  props: {
    initialValue: {
      required: false,
    },
    name: {
      type: String,
      require: true,
    },
    label: {
      type: String,
      required: false,
      default: "",
    },
    labelInfo: {
      type: String,
      default: "",
      required: false,
    },
    value: {
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  components: { SimpleLabel },
  mixins: [],
  data: function () {
    return {};
  },
  methods: {
    emit(ev) {
      this.$emit("input", ev.target.value);
    },
    onChange() {
      if (this.useForm) {
        this.$parent.form.errors.clear(name);
      }
    },
  },
  computed: {
    useForm() {
      return this.$parent.form !== undefined;
    },
  },
  mounted() {},
};
</script>

<style></style>
